import React from "react";
import ProcedureSessionController from "../procedures/ProcedureSessionController";
import { useToast } from "../../common/ToastProvider";
import Button from "../../common/Button";
import "./ProcedurePage.css";

interface PatientRow {
  patient_id: string;
  [key: string]: unknown;
}

interface VisitRow {
  visit_id: string;
  [key: string]: unknown;
}

export interface ProcedurePageProps {
  masterId?: string | null;
  patient?: PatientRow | null;
  visit?: VisitRow | null;
  tooth?: string | null;
  surface?: string | null;
  diagnosisCode?: string | null;
  isLocked?: boolean;
  consultantName?: string | null;
  onBack?: () => void;
  onComplete?: (session?: unknown) => void;
}

export default function ProcedurePage({
  masterId,
  patient,
  visit,
  tooth,
  surface,
  diagnosisCode,
  isLocked,
  consultantName,
  onBack,
  onComplete,
}: ProcedurePageProps) {
  const { showToast } = useToast();
  if (!masterId || !patient || !visit) return null;

  return (
    <div className="mod-standalone-window procedure-page-shell">
      <header className="mod-window-header procedure-page-header">
        <Button variant="ghost" onClick={onBack} className="procedure-page-back">
          ← Back to Clinical Notes
        </Button>
      </header>
      <div className="procedure-page-body">
        <ProcedureSessionController
          patientId={patient.patient_id}
          visitId={visit.visit_id}
          toothNo={tooth}
          diagnosisCode={diagnosisCode}
          masterId={masterId}
          initialSession={null}
          isLocked={isLocked}
          consultantName={consultantName}
          showToast={showToast}
          onUpdated={(session) => {
            if (onComplete) onComplete(session);
          }}
          onClearWorkflow={() => { }}
        />
      </div>
    </div>
  );
}
